<template>
<div class="card">
  <div class="card-body">
    <div class="row">
    <div class="row mb-3">
      <div class="col-lg-12 d-flex flex-wrap">
        <div>
          <p class="text-center">Gösterilen Kayıt Sayısı</p>
          <v-btn-toggle mandatory solo dense>
            <v-btn @click="perPage = 10"> 10 </v-btn>
            <v-btn @click="perPage = 20"> 20 </v-btn>
            <v-btn @click="perPage = 30"> 30 </v-btn>
            <v-btn @click="perPage = 50"> 50 </v-btn>
            <v-btn @click="perPage = 100"> 100 </v-btn>
          </v-btn-toggle>
        </div>
        <div class="ms-auto">
          <v-text-field
            v-model="searchText"
            class="mt-5 pt-3"
            outlined
            rounded
            dense
            placeholder="Arama Yapın..."
            clearable
            hide-details
            append-icon="mdi-magnify"
            @click:append="_fetchErpOrders"
            @keydown.enter="_fetchErpOrders"
          ></v-text-field>
        </div>
      </div>
    </div>
    <div class="row">
      <ResultTableView :perPage="perPage" :currentPage="currentPage"></ResultTableView>
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12 mb-5">
        <v-pagination
          v-model="currentPage"
          class="my-4"
          :length="parseInt(this.erpOrders.length / this.perPage) + 1"
          :total-visible="8"
        ></v-pagination>
      </div>
    </div>
  </div>
  </div>
  
</div>
  
</template>

<script>
import ResultTableView from "@/components/orders/ERPOrders/results/ResultsTableView";

import { mapState, mapActions } from "vuex";

export default {
  components: {
    ResultTableView
  },
  props:{
    listType:{
      type: String,
      default: "SiparisList"
    }
  },
  created() {
    this._fetchErpOrders();
  },

  computed: {
    ...mapState("order", ["erpOrders"]),
    ...mapState("auth", ["user"]),
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      searchText: ""
    };
  },
  methods: {
    ...mapActions("order", ["fetchErpOrders"]),
    _fetchErpOrders(){
      this.fetchErpOrders({
        params: {
          userId: this.user.UserId,
          pageNumber: this.currentPage,
          pageSize: this.perPage,
          ...(!(this.searchText === "" || this.searchText == null)) && {searchText: this.searchText },
          ...(this.user.RoleGroupId === "3") && {currentCode: this.user.userInfo.erpCode},
          ...(this.user.RoleGroupId === "2") && {salesPersonCode: this.user.SalesPersonCode}
        },
        body: {

        }
      })
    }
  },
  watch: {

    perPage: function (newVal) {
      newVal;
      this.currentPage = 1;
    },

    currentPage: function (newVal) {
      newVal;
      this._fetchErpOrders();
    },

  }
};
</script>